<template>
  <v-container fluid>
    <v-dialog v-model="preloader" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Aguarde, Por Favor!
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table :headers="headers" class="elevation-1" :items="users">
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="activeFilters"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <router-link :to="{ name: 'licenca-formulario', path: 'novo' }">
            <v-btn depressed color="secundary">
              <v-icon class="mdi mdi-account-plus mr-2" />Novo Cadastro
            </v-btn>
          </router-link>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          text
          v-if="item.actions.canView && !item.actions.canEdit"
        >
          <v-icon class="mdi mdi-magnify" small />
        </v-btn>
        <v-btn
          icon
          small
          text
          v-if="item.actions.canEdit"
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          titulo="Deletar Licença"
          texto="Confirma a exclusão?"
          v-if="item.actions.canEdit"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
export default {
  components: { DatatableFilters, DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Empresa", value: "id_empresa.text" },
        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      filters: [
        {
          name: "descricao",
          label: "Descrição",
          type: "text",
          defaultValue: ""
        },
        {
          name: "grupoitem",
          label: "Empresa",
          type: "text",
          defaultValue: ""
        }
      ],
      activeFilters: {},
      preloader: false,
      dialogConfirm: false
    };
  },
  computed: {
    users() {
      return this.$store.state.licenca.licenca;
    }
  },
  methods: {
    deletar(id) {
      this.$store.dispatch("licenca/deletar", { id });

      this.$store.dispatch("licenca/listar");
    },
    editar(id) {
      this.$router.replace({
        path: "editar",
        name: "licenca-formulario-editar",
        params: { id }
      });
    }
  },
  watch: {
    activeFilters: function() {
      var filtro = [];
      for (let filter in this.activeFilters) {
        filtro.filtro = filter;
        filtro.valor = this.activeFilters[filter];
      }
      this.$store.dispatch("licenca/buscar", filtro);
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de Licenças"
    });
    this.preloader = true;
    this.$store.dispatch("licenca/listar");
    this.preloader = false;
  }
};
</script>
